<template>
  <v-dialog v-model="open" max-width="760" persistent scrollable class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="isEdit">
            <span style="color: #2655F1;">编辑</span><span>储能方阵</span>
          </template>
          <template v-else>
            <span style="color: #2655F1;">新增</span><span>储能方阵</span>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>

      <v-card-text class="pa-8 pt-0">
        <!-- 集中式：Galaxy -->
        <div v-if="!isDistributedStation" class="galaxy-section">
          <div class="gm-form-section mb-0">
            <h3 class="gm-form-subsection">Galaxy</h3>
            <div class="galaxy-panel">
              <div class="form-grid-2">
                <div class="form-group">
                  <label>Galaxy名称 <span class="required-star">*</span></label>
                  <v-text-field v-model="galaxyDraft.name" placeholder="请输入Galaxy名称" variant="flat" density="compact"
                    class="gm-input" hide-details />
                </div>
                <div class="form-group">
                  <label>Galaxy型号 <span class="required-star">*</span></label>
                  <v-select v-model="galaxyDraft.modelTag" :items="filteredEblockModelOptions" item-title="title"
                    item-value="value" placeholder="请选择Galaxy型号" variant="flat" density="compact" class="gm-input"
                    hide-details no-data-text="无匹配型号" />
                </div>
                <div class="form-group">
                  <label>UUID</label>
                  <v-text-field v-model="galaxyDraft.uuid" placeholder="根据序号自动生成UUID" variant="flat" density="compact"
                    class="gm-input" hide-details readonly />
                </div>
              </div>
              <div class="galaxy-metrics-grid">
                <div class="galaxy-metric">
                  <span class="galaxy-metric-label">电池簇数量</span>
                  <span class="galaxy-metric-value">{{ galaxyDraft.clusterCount || galaxyDraft.clusterCount === 0 ?
                    galaxyDraft.clusterCount : '—' }}</span>
                </div>
                <div class="galaxy-metric">
                  <span class="galaxy-metric-label">PCS数量</span>
                  <span class="galaxy-metric-value">{{ galaxyDraft.pcsCount || galaxyDraft.pcsCount === 0 ?
                    galaxyDraft.pcsCount : '—' }}</span>
                </div>
                <div class="galaxy-metric">
                  <span class="galaxy-metric-label">电池簇型号</span>
                  <span class="galaxy-metric-value">{{ galaxyDraft.batteryClusterModel || '—' }}</span>
                </div>
                <div class="galaxy-metric">
                  <span class="galaxy-metric-label">PCS型号</span>
                  <span class="galaxy-metric-value">{{ galaxyDraft.pcsModel || '—' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 能量链基础字段 -->
        <div class="gm-form-section mt-4">
          <h3 class="gm-form-subsection">能量链</h3>
          <div class="form-grid-2">
            <div class="form-group">
              <label>能量链名称 <span class="required-star">*</span></label>
              <v-text-field v-model="elinkDraft.eLinkName" placeholder="请输入能量链名称" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>能量链型号</label>
              <v-select v-model="elinkDraft.modelTag" :items="elinkModelOptions" item-title="title" item-value="value"
                placeholder="请选择能量链型号" variant="flat" density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>能量链UUID <span class="required-star">*</span></label>
              <v-text-field v-model="elinkDraft.uuid" placeholder="根据序号自动生成UUID" variant="flat" density="compact"
                class="gm-input" hide-details readonly />
            </div>
            <div class="form-group">
              <label>序号 <span class="required-star">*</span></label>
              <v-text-field v-model="elinkDraft.badge" placeholder="请输入序号" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>设备网络ID</label>
              <v-text-field v-model="elinkDraft.deviceNetworkId" placeholder="请输入设备网络ID" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>计量点传输距离（米）</label>
              <v-text-field v-model="elinkDraft.measuringDistance" placeholder="请输入计量点传输距离" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
          </div>
        </div>

        <!-- eLink 水机（仅新增时可见） -->
        <div v-if="!isEdit" class="gm-form-section">
          <div class="d-flex align-center justify-space-between flex-wrap ga-2 mb-4">
            <h3 class="gm-form-subsection mb-0">eLink 水机</h3>
            <v-btn color="var(--color-primary)" variant="tonal" size="small" rounded="lg" prepend-icon="mdi-plus"
              @click="emit('add-water-machine')">
              新增 eLink 水机
            </v-btn>
          </div>
          <div v-if="elinkDraft.waterMachineList.length">
            <div v-for="(wm, idx) in elinkDraft.waterMachineList" :key="wm.key" class="gm-metering-block">
              <div class="gm-metering-row">
                <div class="form-grid-4 gm-metering-fields">
                  <div class="form-group">
                    <label>水机名称 <span class="required-star">*</span></label>
                    <v-text-field :model-value="wm.name" variant="flat" density="compact" class="gm-input" hide-details
                      readonly />
                  </div>
                  <div class="form-group">
                    <label>水机产品型号 <span class="required-star">*</span></label>
                    <v-select :model-value="wm.productModel" :items="conditionerModelOptions" item-title="title"
                      item-value="value" :loading="conditionerModelLoading" placeholder="请选择水机产品型号" variant="flat"
                      density="compact" class="gm-input" hide-details clearable
                      @update:model-value="emit('update-water-machine-model', idx, $event)" />
                  </div>
                  <div class="form-group">
                    <label>水机 UUID <span class="required-star">*</span></label>
                    <v-text-field :model-value="wm.uuid" variant="flat" density="compact" class="gm-input" hide-details
                      readonly />
                  </div>
                  <div class="form-group">
                    <label>水机设备 devID <span class="required-star">*</span></label>
                    <v-text-field v-model="wm.deviceId" placeholder="请输入设备devID" variant="flat" density="compact"
                      class="gm-input" hide-details />
                  </div>
                </div>
                <div class="gm-metering-action gm-metering-action--inline">
                  <v-btn variant="text" size="small" color="#FF6A46" @click="emit('remove-water-machine', wm)">
                    删除
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-body-2 text-medium-emphasis mt-2">
            暂无 eLink 水机，请点击新增 eLink 水机。
          </div>
        </div>

        <!-- eBlock 批量创建（仅新增 + 分散式） -->
        <div v-if="!isEdit && isDistributedStation" class="gm-form-section">
          <div class="d-flex align-center justify-space-between flex-wrap ga-2 mb-4">
            <h3 class="gm-form-subsection mb-0">eBlock</h3>
          </div>
          <div class="form-grid-2">
            <div class="form-group">
              <label>eBlock 数量 <span class="required-star">*</span></label>
              <v-text-field v-model.number="elinkDraft.eblockCount" type="number" min="1" placeholder="请输入 eBlock 数量"
                variant="flat" density="compact" class="gm-input" hide-details :readonly="isEdit" />
            </div>
            <div class="form-group">
              <label>型号 <span class="required-star">*</span></label>
              <v-autocomplete v-model="elinkDraft.eblockModelTag" :items="filteredEblockModelOptions" item-title="title"
                item-value="value" placeholder="请输入关键字筛选并选择型号" variant="flat" density="compact" class="gm-input"
                hide-details :disabled="isEdit" auto-select-first no-data-text="无匹配型号" />
            </div>
            <div v-if="selectedEblockClusterInfo"
              class="galaxy-metrics-grid galaxy-metrics-grid--inline eblock-cluster-info">
              <div class="galaxy-metric">
                <span class="galaxy-metric-label">电池簇数量</span>
                <span class="galaxy-metric-value">{{ selectedEblockClusterInfo.clusterCount }}</span>
              </div>
              <div class="galaxy-metric">
                <span class="galaxy-metric-label">电池簇型号</span>
                <span class="galaxy-metric-value">{{ selectedEblockClusterInfo.batteryClusterModel || '—' }}</span>
              </div>
            </div>
            <div v-if="showDraftEblockWaterMachineFields" class="form-group">
              <label>水机产品型号</label>
              <v-select v-model="elinkDraft.eblockWaterMachineModel" :items="conditionerModelOptions" item-title="title"
                item-value="value" :loading="conditionerModelLoading" placeholder="请选择水机产品型号" variant="flat"
                density="compact" class="gm-input" hide-details clearable :disabled="isEdit" />
            </div>
          </div>
          <div class="text-body-2 text-medium-emphasis mt-3">
            请填写数量和型号，将自动生成名称、UUID 和设备 devID；计量电表 UUID 也会按能量链序号和行序自动生成。
          </div>
        </div>

        <!-- 计量电表（仅新增） -->
        <div v-if="!isEdit" class="gm-form-section">
          <div class="d-flex align-center justify-space-between flex-wrap ga-2 mb-4">
            <h3 class="gm-form-subsection mb-0">计量电表</h3>
            <v-btn color="var(--color-primary)" variant="tonal" size="small" rounded="lg" prepend-icon="mdi-plus"
              :disabled="isEdit" @click="emit('add-metering-meter')">
              新增计量电表
            </v-btn>
          </div>
          <div v-for="(mm, idx) in elinkDraft.meteringMeters" :key="mm.key" class="gm-metering-block">
            <div class="gm-metering-row">
              <div class="form-grid-3 gm-metering-fields">
                <div class="form-group">
                  <label>计量电表名称 <span class="required-star">*</span></label>
                  <v-text-field v-model="mm.name" placeholder="请输入名称" variant="flat" density="compact" class="gm-input"
                    hide-details :readonly="isEdit" />
                </div>
                <div class="form-group">
                  <label>计量电表UUID <span class="required-star">*</span></label>
                  <v-text-field v-model="mm.uuid" placeholder="根据序号自动生成UUID" variant="flat" density="compact"
                    class="gm-input" hide-details readonly />
                </div>
                <div class="form-group">
                  <label>计量电表设备devID <span class="required-star">*</span></label>
                  <v-text-field v-model="mm.deviceId" placeholder="请输入设备devID" variant="flat" density="compact"
                    class="gm-input" hide-details :readonly="isEdit" />
                </div>
              </div>
              <div class="gm-metering-action">
                <v-btn variant="text" size="small" color="#FF6A46" :disabled="isEdit"
                  @click="emit('remove-metering-meter', idx)">
                  删除
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="submitting"
          @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { elinkModelOptions } from '../utils/constants'

const open = defineModel({ type: Boolean, default: false })
const props = defineProps({
  isEdit: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  isDistributedStation: { type: Boolean, default: false },
  galaxyDraft: { type: Object, required: true },
  elinkDraft: { type: Object, required: true },
  filteredEblockModelOptions: { type: Array, default: () => [] },
  showDraftEblockWaterMachineFields: { type: Boolean, default: false },
  conditionerModelOptions: { type: Array, default: () => [] },
  conditionerModelLoading: { type: Boolean, default: false },
})
const emit = defineEmits([
  'close',
  'submit',
  'add-water-machine',
  'update-water-machine-model',
  'remove-water-machine',
  'add-metering-meter',
  'remove-metering-meter',
])

// 当所选 eBlock 型号包含多个电池簇（clusterCount > 1）时，在提示文字下额外展示电池簇数量与型号
const selectedEblockClusterInfo = computed(() => {
  const modelTag = String(props.elinkDraft?.eblockModelTag ?? '').trim()
  if (!modelTag) return null
  const option = props.filteredEblockModelOptions.find((item) => item.value === modelTag)
  const raw = option?.raw ?? null
  if (!raw) return null
  const clusterCount = Number(raw.clusterCount)
  if (!Number.isFinite(clusterCount) || clusterCount <= 1) return null
  return {
    clusterCount,
    batteryClusterModel: String(raw.batteryClusterModel ?? '').trim(),
  }
})
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
